import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';

type Props = {
    onLearnMore: () => void;
};

const DocIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#0E62F4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
    >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
);

// Advance settings 完成页底部的 credentialing 入口：只对还没开始 credentialing 的 provider 展示，
// 展示与否由调用方判断（见 PPAAdvanceSettingSuccessPage）。
export default function GetCredentialedCard({ onLearnMore }: Props) {
    return (
        <div className={s.card}>
            <div className={s.head}>
                <span className={s.iconTile}>
                    <DocIcon />
                </span>
                <div className={s.body}>
                    <div className={s.title}>Get credentialed with major insurances</div>
                    <div className={s.desc}>
                        Get on payer panels under your own NPI, so the contracts stay yours. No service fee, just a $50
                        deposit per panel, and the first three come back after your first claim.
                    </div>
                </div>
            </div>
            <Button block className={s.learnBtn} onClick={onLearnMore}>
                Learn about credentialing
            </Button>
        </div>
    );
}
